function lazyLoadVideos() {
  const videos = document.querySelectorAll("video");

  if (!videos.length) return;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        const video = entry.target;

        if (entry.isIntersecting) {
          loadVideo(video);

          if (video.autoplay) {
            video.play().catch(() => {});
          }
        } else {
          video.pause();
        }

        // Stop observing once we've loaded it
        if (entry.isIntersecting) {
          obs.unobserve(video);
        }
      });
    },
    {
      rootMargin: "500px 0px",
    },
  );

  videos.forEach((video) => observer.observe(video));
}

/**
 * Resolve correct video source based on available configuration
 */
function resolveVideoSrc(video) {
  const mobile = video.dataset.srcMobile;
  const desktop = video.dataset.srcDesktop;
  const mediaQuery = video.dataset.mediaQuery;

  const hasMobile = !!mobile;
  const hasDesktop = !!desktop;

  const hasBoth = hasMobile && hasDesktop;

  // Case 1: Only one source exists → always use it
  if (!hasBoth) {
    return mobile || desktop || null;
  }

  // Case 2: Both exist → use media query if provided
  if (mediaQuery) {
    const isMatch = window.matchMedia(mediaQuery).matches;
    return isMatch ? mobile : desktop;
  }

  // Case 3: Both exist but no media query → default to desktop
  return desktop;
}

/**
 * Load video safely (idempotent)
 */
function loadVideo(video) {
  if (video.dataset.loaded === "true") return;

  const source = video.querySelector("source");
  if (!source) return;

  let src = null;

  // Standard lazy-loaded <source data-src="">
  if (source.dataset.src) {
    src = source.dataset.src;
  } else {
    // Responsive or single-source fallback
    src = resolveVideoSrc(video);
  }

  if (!src) return;

  source.src = src;
  video.load();

  video.dataset.loaded = "true";
}

export default lazyLoadVideos;
